import { Vue as _Vue } from 'vue/types/vue'
import { VueModule } from 'vue-modules'
import VueRouter from 'vue-router'
import { Store } from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuetify from '../../plugins/vuetify'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import App from './components/App.vue'
import VueChatScroll from 'vue-chat-scroll'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'
import VueAuthenticate from 'vue-authenticate'

export class CoreModule implements VueModule {
  readonly name = 'core';
  public vue: any;
  constructor (private router: VueRouter, private store: Store<any>) {}
  install (Vue: typeof _Vue) {
    // ref https://vuex.vuejs.org/guide/modules.html#dynamic-module-registration
    // this.store.registerModule([this.name, "error"], SnackbarStore);

    Vue.use(VueTelInputVuetify, { vuetify }) // ref https://github.com/yogakurniawan/vue-tel-input-vuetify#npm

    this.vue = new Vue({
      router: this.router,
      store: this.store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')

    Vue.use(VueAxios, axios) // need it for VueAuthenticate

    Vue.use(VueAuthenticate, {
      providers: {
        linkedin: {
          clientId: '860a9egnzmfo19',
          redirectUri: 'http://localhost:8080/',
          url: 'http://localhost:8000/api/login/social/token_user/linkedin-oauth2/',
          scope: ['r_emailaddress', 'r_liteprofile', 'w_member_social'],
          requiredUrlParams: ['state', 'scope'],
          tokenPath: 'token'
        }
      }
    })

    Vue.use(TiptapVuetifyPlugin, {
      // ref https://github.com/iliyaZelenko/tiptap-vuetify
      vuetify,
      iconsGroup: 'mdi'
    })

    Vue.use(VueChatScroll) // ref https://github.com/theomessin/vue-chat-scroll
  }
}
